<template>
  <div class="p-5 text-center text-muted">
    <div class="spinner-border text-warning" role="status">
      <span class="visually-hidden">{{ $t('common.loading') }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "AddquotaVue",
  mounted() {
    this.$router.replace({ name: "QuotaAdd" });
  },
};
</script>
